var React = require('react');

function Playstore (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M99.617,8.057C87.953,0.52,73.943-1.758,60.802,1.344l230.932,230.933l74.846-74.846L99.617,8.057z","key":0}),React.createElement("path",{"d":"M32.139,20.116c-6.441,8.563-10.148,19.077-10.148,30.199v411.358c0,11.123,3.708,21.636,10.148,30.199l235.877-235.877\n\t\t\tL32.139,20.116z","key":1}),React.createElement("path",{"d":"M464.261,212.087l-67.266-37.637l-81.544,81.544l81.548,81.548l67.273-37.64c16.117-9.03,25.738-25.442,25.738-43.908\n\t\t\tS480.389,221.117,464.261,212.087z","key":2}),React.createElement("path",{"d":"M291.733,279.711L60.815,510.629c3.786,0.891,7.639,1.371,11.492,1.371c9.522,0,19.011-2.708,27.31-8.07l266.965-149.372\n\t\t\tL291.733,279.711z","key":3})]);
}

Playstore.defaultProps = {"viewBox":"-40 -40 590 590"};

module.exports = Playstore;

Playstore.default = Playstore;
